import { PopperBase } from './popper-base';
import { LineCalendarCell, LineSelectedCell } from "../model";
import { PLANNER_CLICK_STATUS } from 'apps/events';
import PopperJS from 'popper.js';
import RiotEventManager from 'utilities/riot/event_manager';
import { PLANNER_CHANGE_STATUS, PLANNER_SUBMIT_STATUS } from 'apps/events';
import { FormStatus } from 'mixs/forms/orders/status';
class UpdateStatus extends PopperBase {
  eventManager: RiotEventManager;
  formElement: HTMLFormElement;
  init(){
    super.init();
    this.watchPlannerData('updateStatus', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeUpdateStatus(newVal, oldVal, objectPath)});
    this.eventManager = new RiotEventManager(this);
    this.eventManager.customEvent(PLANNER_CHANGE_STATUS, () => { this.onChangeStatus() });
  }
  onChangeUpdateStatus(newVal, oldVal, objectPath){
    if(newVal === null) {
      this.hide();
    } else {
      this.show(newVal);
    }
  }
  hide(){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  show(newVal){
    let newValue = { forms_orders_status: {
      action: '/orders/' + newVal.opts.id + '/update_status',
      inputs: { status: { value: newVal.opts.status } }
    }};
    App.store.dispatch(App.actions.data.update(newValue));
    this.dispatchNewValue(newVal);
    this.isShow = true;
    let popper = new PopperJS(
      newVal.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
  }
  onClose(){
    // let e = new CustomEvent(PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE, {});
    // document.dispatchEvent(e);
  }
  onChangeStatus() {
    let formTag = <any>this.tags['forms-orders-status'];
    formTag.submit();
    let e = new CustomEvent(PLANNER_SUBMIT_STATUS, {});
    document.dispatchEvent(e);
  }
}
let scope = 'orders.planner.dialog.update-status';
riot.mixin(scope, UpdateStatus as riot.TagMixin);
